import "./loader.scss";
import loader from "../../assets/loader.png";
import { ILoader } from "./interface";

const Loader = ({ size = 48, style }: ILoader) => {
  return (
    <div style={{ ...style }} data-testid="loader" className="loader-content">
      <img
        src={loader}
        data-testid="loader-image"
        alt=""
        width={size}
        height={size}
        className="loader"
      />
    </div>
  );
};

export default Loader;
